import { render, staticRenderFns } from "./vis-concent-scope.vue?vue&type=template&id=664ce3f2"
import script from "./vis-concent-scope.vue?vue&type=script&lang=js"
export * from "./vis-concent-scope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports